import React from 'react';

import { MonthlyActiveUser } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Column from '@amzn/meridian/column';

import { isNil } from 'lodash';
import { ViewMonthlyActiveUser } from 'src/components/ViewPrimeAMFRateCard/ViewContractTerms/ViewMonthlyActiveUser/ViewMonthlyActiveUser';
import { AppContext } from 'src/contexts/appContext';
import { IAdRevShare, IPrimeContractTerms } from 'src/types/IRateCard';
import { IAmfContractTerms } from 'src/types/IRateCard';

import { ViewAdRevShare } from './ViewAdRevShare';
import { ViewCostPerPlay } from './ViewCostPerPlay';

interface IViewContractTermsProps {
    primeContractTerms?: IPrimeContractTerms;
    amfContractTerms?: IAmfContractTerms;
    serviceId: number;
}

function shouldRenderMonthlyActiveUser(monthlyActiveUser: MonthlyActiveUser | undefined): boolean {
    const customerTypes = monthlyActiveUser?.customerType;
    return !isNil(customerTypes) && customerTypes.length > 0;
}

function shouldRenderAdRevShare(adRevShare: IAdRevShare | undefined): boolean {
    return !isNil(adRevShare);
}

export const ViewContractTerms = ({ primeContractTerms, amfContractTerms, serviceId }: IViewContractTermsProps) => {
    const { metadata } = React.useContext(AppContext);
    const services = metadata.serviceMapping;

    const renderMAU = shouldRenderMonthlyActiveUser(primeContractTerms?.monthlyActiveUser);
    const renderAdRevShare = shouldRenderAdRevShare(primeContractTerms?.adRevShare);

    return (
        <Column className="contract-terms-width">
            {serviceId === services[2].serviceId ? (
                <>
                    <ViewCostPerPlay
                        costPerPlay={primeContractTerms!.costPerPlay!}
                        prsDeductionCap={primeContractTerms!.prsDeductionCap!}
                        serviceId={serviceId}
                    />
                    {renderMAU && <ViewMonthlyActiveUser monthlyActiveUser={primeContractTerms!.monthlyActiveUser!} />}
                    {renderAdRevShare && (
                        <ViewAdRevShare adRevShare={primeContractTerms!.adRevShare!} serviceId={serviceId} />
                    )}
                </>
            ) : (
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                <ViewAdRevShare adRevShare={amfContractTerms!.adRevShare!} serviceId={serviceId} />
            )}
        </Column>
    );
};
